<span class="cursor-pointer" (click)="toggleSort()">
    <ng-content></ng-content>
    <span
      *ngIf="arrowIconPath"
      class="ms-2 svg-icon svg-icon-3"
      [inlineSVG]="arrowIconPath"
    ></span>
</span>
